import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import InputText from '../InputText/InputText';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './PatientPortalRouter.module.css';

function PatientPortalRouter({ open, onClose }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        setEmail('');
        setError('');
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(
                `${process.env.REACT_APP_TB2_API_URL}/patients/route-patient?email=${encodeURIComponent(email)}`
            );
            if (!res.ok) throw new Error();
            const { route, tempToken } = await res.json();
            const url = route === 'patient-portal'
                ? `${process.env.REACT_APP_PATIENT_PORTAL_URL}/signin?tempToken=${tempToken}`
                : 'https://patient.tb2.health';
            console.log('Opening URL:', url);
            window.open(url, '_blank', 'noopener,noreferrer');
            handleClose();
        } catch {
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth PaperProps={{sx: { borderRadius: '12px' }}}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.dialogContent}>
                    <h3 className={styles.dialogTitle}>Access Your Patient Portal</h3>
                    <InputText
                        label="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        fullWidth
                        autoFocus
                        margin="dense"
                        disabled={loading}
                    />
                    {error && (
                        <p style={{ color: '#d32f2f', fontSize: '0.875rem', margin: '8px 0 0' }}>
                            {error}
                        </p>
                    )}
                </div>
                <div className={styles.dialogActions}>
                    <button
                        type="button"
                        className={styles.secondaryButton}
                        onClick={handleClose}
                    >
                        Back
                    </button>
                    <button 
                        className={`${styles.primaryButton} ${loading ? styles.disabledButton : ''}`}
                        type="submit"
                    >
                        Continue
                    </button>
                </div>
            </form>
        </Dialog>
    );
}

export default PatientPortalRouter;
